// src/components/assinatura/BloqueioTeste.js — página fechada no período de
// teste (out/26): Agenda, Automação e Formulários.
//
// A página carrega normal por baixo, desfocada e inerte (sem clique, sem
// Tab, fora do leitor de tela), e o cartão AtivarAssinatura fica por cima.
// Ver a própria página atrás do vidro é de propósito: a pessoa enxerga o que
// vai ganhar. O menu e a TopBar continuam funcionando — dá pra ir pra outra
// página sem ativar.
//
// Só a TELA fecha: as rotas da API continuam abertas (o CRM marca retorno
// na Agenda, o chat envia formulário publicado). O objetivo é levar a
// assinar logo, não cortar dado que a pessoa já tem.
//
// A estrutura é a mesma com e sem teste (a caixa de fora e a de dentro
// sempre existem): trocar a árvore ao ativar remontaria a página e perderia
// o momento em que ela volta ao foco.
import { useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAssinatura from '../../hooks/useAssinatura';
import AtivarAssinatura from './AtivarAssinatura';

/**
 * @param {object} props
 * @param {'agenda'|'automacao'|'formularios'} props.pagina
 * @param {object} [props.sx]  O sx da área de conteúdo da página (a caixa de dentro).
 */
export default function BloqueioTeste({ pagina, sx, children }) {
  const navigate = useNavigate();
  const { emTeste } = useAssinatura();
  // Ativou aqui: a releitura da assinatura chega logo depois da cobrança e
  // tira o `emTeste`, mas o cartão de "pronto" segura a tela (`cobrada`) até
  // o clique em "Abrir…" — só então a página volta ao foco.
  const [cobrada, setCobrada] = useState(false);
  const [liberada, setLiberada] = useState(false);
  const fechada = (emTeste || cobrada) && !liberada;

  return (
    <Box sx={[
      { position: 'relative', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' },
      // Página comprida (lista de formulários): fechada, ela para na altura
      // da tela — senão o cartão ficava no meio da lista, fora da vista.
      fechada && { maxHeight: 'calc(100dvh - 54px)', overflow: 'hidden' },
    ]}>
      <Box
        inert={fechada || undefined}
        aria-hidden={fechada || undefined}
        sx={[
          { flex: 1, minHeight: 0 },
          ...(Array.isArray(sx) ? sx : [sx]),
          {
            filter: fechada ? 'blur(7px) saturate(0.85)' : 'none',
            transition: 'filter .8s cubic-bezier(.2,.7,.2,1)',
            '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
          },
          fechada && { pointerEvents: 'none', userSelect: 'none' },
        ]}
      >
        {children}
      </Box>

      {fechada && (
        <Box sx={{
          position: 'absolute', inset: 0, zIndex: 5, overflowY: 'auto',
          display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'center',
          p: { xs: '16px', sm: 3 },
          bgcolor: 'rgba(7,11,20,0.30)',
        }}>
          <AtivarAssinatura
            pagina={pagina}
            onCobrada={() => setCobrada(true)}
            onAtivada={() => setLiberada(true)}
            onVoltar={() => navigate('/dashboard')}
          />
        </Box>
      )}
    </Box>
  );
}
